import React, { useState, useEffect } from 'react'
import '../Styles/Invoice.css'
import axios from 'axios'
import { useNavigate } from 'react-router';
import Filter from '../components/Filter';
import Currency from '../components/Currency';
export default function Invoice() {
    const [data, setData] = useState([
        // { Pname: 'Very Long Project Name', rate: '1000$', dueDate: '24-10-2022', status: 'APPROVED AND PAID' },
        // { Pname: 'Very Long Project Name', rate: '1000$', dueDate: '24-10-2022', status: 'APPROVED' },
        // { Pname: 'Very Long Project Name', rate: '1000$', dueDate: '24-10-2022', status: 'REJECTED' },
        // { Pname: 'Very Long Project Name', rate: '1000$', dueDate: '24-10-2022', status: 'APPROVED' },
        // { Pname: 'Very Long Project Name', rate: '1000$', dueDate: '24-10-2022', status: 'APPROVED' },
        // { Pname: 'Very Long Project Name', rate: '1000$', dueDate: '24-10-2022', status: 'REJECTED' },
        // { Pname: 'Very Long Project Name', rate: '1000$', dueDate: '24-10-2022', status: 'AAPPROVED AND PAID' },
        // { Pname: 'Very Long Project Name', rate: '1000$', dueDate: '24-10-2022', status: 'REJECTED' },
        // { Pname: 'Very Long Project Name', rate: '1000$', dueDate: '24-10-2022', status: 'APPROVED AND PAID' },
        // { Pname: 'Very Long Project Name', rate: '1000$', dueDate: '24-10-2022', status: 'REJECTED' },
    ])
    const [temp, setTemp] = useState([])
    const getInvoices = async () => {
        let url = `${type == 'ACCOUNTANT' ? 'account/invoice/' : 'consultant/Invoice_module/'}`
        await axios.get(`${process.env.REACT_APP_API_URL1}/${url}`, {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `JWT ${localStorage.getItem('access')}`,
                'Accept': 'application/json'
            }
        })
            .then(async response => {
                setboler(true)
                setTemp([...response.data]);
                // for (var option of document.getElementById("curselect").options) {
                //     if (option.value === curcur) {
                //         option.selected = true;
                //         break;
                //     }
                // }
                let currency = JSON.parse(localStorage.getItem('currency'))
                setData(response.data.map((e) => {
                    document.getElementById('Pnames').innerHTML += `<option value='${e.project_name + ' - id ' + e.project}'/>`
                    return e
                }))
                console.log(response.data)
            }).catch(err => {
                let notify = document.getElementsByClassName('noti')[0];
                notify.innerHTML += `<div style="background-color:#f8d7da;color:#721c24" class='notifyUser'>
                                ${err.response.data.message}
                            </div>`;
                setTimeout(() => {
                    notify.removeChild(notify.lastChild)
                }, 3000);
                console.log(err)
            })
        await axios.get(`${process.env.REACT_APP_API_URL1}/${type == 'ACCOUNTANT' ? 'account/projects/' : type == 'CONSULTANT' ? 'consultant/projects/' : 'project/projects/'}`, {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `JWT ${localStorage.getItem('access')}`,
                'Accept': 'application/json'
            }
        })
            .then(async response => {
                setLoad(false)
                await response.data.map((e) => {
                    document.getElementById('projdrop').innerHTML +=
                        `<option value='${e.id}'>${e.project_name}</option>`
                })
            }).catch(err => {
                console.log(err)
                setLoad(false)
                if(err.response.status==500){
                    try {
                        notify.innerHTML += `<div style="background-color:#f8d7da;color:#721c24" class='notifyUser'>
                        Server busy, Please try after some time
                        </div>`;
                        setTimeout(() => {
                            notify.removeChild(notify.lastChild)
                        }, 3000);
                    } catch (e) { console.log(e) }
                }
                let notify = document.getElementsByClassName('noti')[0];
            })
    }
    useEffect(async () => {
        if (!curcur) { curcur = 'INR'; localStorage.setItem('selectedCurrency', 'INR') }
        if (!symbol) { setSymbol('/-'); localStorage.setItem('symbol', '/-') }
        await getInvoices()
    }, [])
    function Invpop() {

        const submitHandler = async e => {
            e.preventDefault();
            console.log(details)
            console.log(count)
            var formData = new FormData();
            // formData.append('project_data',
            //     // dateObj.getUTCFullYear() + "-" + (dateObj.getUTCMonth() + 1) + "-" + dateObj.getUTCDate()
            //     '1'
            // );
            formData.append('due_date', document.getElementById(`duedate_drop`).value)
            formData.append('no_of_field', count)
            formData.append('project_data', document.getElementById(`projdrop`).value)
            for (let i = 1; i < count + 1; i++) {
                formData.append(`sub_description${i}`, document.getElementById(`subdesc${i}`).value)
                formData.append(`desc${i}`, document.getElementById(`select${i}`).value)
                formData.append(`unit${i}`, document.getElementById(`hours${i}`).value)
                formData.append(`coast${i}`, document.getElementById(`rate${i}`).value)
            }
            let notify = document.getElementsByClassName('noti')[0];
            await axios({
                method: "post",
                url: `${process.env.REACT_APP_API_URL1}/consultant/Invoice_module/`,
                data: formData,
                headers: {
                    "Content-Type": "multipart/form-data",
                    'Authorization': `JWT ${localStorage.getItem('access')}`,
                    'Accept': 'application/json'
                },
            }).then(async response => {
                console.log(response)
                notify.innerHTML += `<div style='background-color:#23C552' class='notifyUser'>
                                ${response.data.message}
                            </div>`;
                await axios.get(`${process.env.REACT_APP_API_URL1}/consultant/Invoice_module/`, {
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': `JWT ${localStorage.getItem('access')}`,
                        'Accept': 'application/json'
                    }
                })
                    .then(async response => {
                        document.getElementsByClassName('showdet')[0].classList.remove('show_hide')
                        setData(response.data)
                        setTimeout(() => {
                            notify.removeChild(notify.lastChild)
                        }, 3000);
                        console.log(response.data)
                    }).catch(err => {
                        console.log(err)
                    })
            }).catch(err => {
                console.log(err)
                console.log(formData)
            })
            // Signup(details);
        }
        const [details, setDetails] = useState({
            project_name: "", cost: "", due_date: "", addDet: "", addsub: ""
        });
        const [error, setError] = useState('')
        const [count, setCount] = useState(1)
        const GenNew = () => {
            setCount(count + 1);
            console.log(count)
            document.getElementById('addrow').innerHTML += `<tr  class='HrDay'>
                <td><input type="number" id=hours${count + 1} placeholder='Hours' />
                <select id='select${count + 1}'>
                    <option value='hours'>Hours</option>
                    <option value='days'>Days</option>
                </select>
                </td>
                <td><input type="number" id=rate${count + 1} placeholder='Rate' /></td>
            </tr>
                <tr>
                    <td rowSpan={2}><textarea type="text" id=subdesc${count + 1} placeholder='Sub Description' ></textarea></td>
                </tr>`
        }
        const [dayH, setDH] = useState('hours')
        return (
            <div className='projDetI'>
                <div className='projright'><i onClick={() =>
                    document.getElementsByClassName('showdet')[0].classList.remove('show_hide')
                } class="fas fa-times"></i>INVOICE</div>
                <form onSubmit={submitHandler}>
                    <div className='form-inner'>
                        {(error !== "") ? <div className='error'>{error}</div> : ""}
                        <table id='table'>
                            <tr>
                                <td style={{ textAlign: 'initial' }}><span style={{ color: 'white', fontSize: '18px' }}>Project Name : &ensp;</span><br />
                                    <span style={{ color: 'white', fontSize: '18px' }}>Due Date : &ensp;</span><br />
                                    <span style={{ color: 'white', fontSize: '18px' }}>Currency : &ensp;</span><br />
                                </td>
                                <td className='invoice-drops'>
                                    <select id='projdrop'>
                                    </select><br />
                                    <select id='duedate_drop'>
                                        <option value='IMMEDIATE'>IMMEDIATE</option>
                                        <option value='N15'>N15</option>
                                        <option value='N30'>N30</option>
                                        <option value='N45'>N45</option>
                                        <option value='N60'>N60</option>
                                    </select><br />
                                    <select id='currency'>
                                        <option value='₹'>INR</option>
                                        <option value='$'>USD</option>
                                        <option value='€'>EUR</option>
                                        <option value='د.إ'>AED</option>
                                    </select>
                                </td>
                            </tr>
                            <tr className='HrDay'>
                                <td ><input type="number" id='hours1' placeholder={dayH} />
                                    <select id='select1' onChange={(e) => setDH(e.target.value)}>
                                        <option value='hours'>Hours</option>
                                        <option value='days'>Days</option>
                                    </select></td>
                                <td><input type="number" id='rate1' placeholder='Rate' /></td>
                            </tr>
                            <tr>
                                <td rowSpan={2}><textarea type="text" id='prodesc1' placeholder='Project Description' ></textarea></td>
                                <td rowSpan={2}><textarea type="text" id='subdesc1' placeholder='Sub Description' /></td>
                            </tr>
                            <table id='addrow'></table>
                            <button type='button' onClick={() => GenNew()}>Add </button>
                        </table>
                        <div className="center">
                            <button type='submit' className='signupbutton'>SUBMIT</button></div>
                    </div>
                </form>
            </div>
        )
    }
    let navigate = useNavigate();
    const [filters, setFil] = useState({})
    const Filtertag = (e) => {
        return <div className='filterBox'>
            {e.name}
            <i style={{ cursor: 'pointer' }} onClick={() => { childFunc.clear(e.id) }} class="fas fa-times"></i>
        </div>
    }
    const childFunc = () => { }
    const curCall = () => { }
    const [booler, setboler] = useState(false)
    var curcur = localStorage.getItem('selectedCurrency')
    const [symbol, setSymbol] = useState(localStorage.getItem('symbol'))
    function numberWithCommas(x) {
        return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    }
    let type = localStorage.getItem('type');
    const [hover, setHov] = useState(false)
    function TabRen() {
        const list=[]
        for (let i = 0; i < 20; i++) {
            list.push(
                <tr>
                    <td class="loadingt">
                        <div class="bar"></div>
                    </td>
                    <td class="loadingt">
                        <div class="bar"></div>
                    </td>
                    <td class="loadingt">
                        <div class="bar"></div>
                    </td>
                    <td class="loadingt">
                        <div class="bar"></div>
                    </td>
                    <td class="loadingt">
                        <div class="bar"></div>
                    </td>
                </tr>
            )
        }
        return (
            <>
                {list}
            </>
        )
    }
    async function changeInv() {
        let notify = document.getElementsByClassName('noti')[0];
        for await (let i of changes) {
            let formData = new FormData();
            formData.append('status', i.status)
            await axios({
                method: "put",
                url: `${process.env.REACT_APP_API_URL1}/account/invoice/${i.slug}/`,
                data: formData,
                headers: {
                    "Content-Type": "multipart/form-data",
                    'Authorization': `JWT ${localStorage.getItem('access')}`,
                    'Accept': 'application/json'
                },
            }).then(async response => {
                console.log(response)
            }).catch(err => {
            })
        }
        await axios.get(`${process.env.REACT_APP_API_URL1}/account/invoice/`, {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `JWT ${localStorage.getItem('access')}`,
                'Accept': 'application/json'
            }
        })
            .then(async response => {
                setData(response.data)
                setHov(false)
                notify.innerHTML += `<div style='background-color:#23C552' class='notifyUser'>
                            Invoices Updated
                        </div>`;
                setTimeout(() => {
                    notify.removeChild(notify.lastChild)
                }, 3000);
                changes = []
                console.log(response.data)
            }).catch(err => {
                changes = []
                setHov(false)
                console.log(err)
            })
    }
    var changes = []
    const [load,setLoad]=useState(true)
    return (
        type == 'CONSULTANT' || type == 'ACCOUNTANT' ? <div className='Projects Invoices'>
            <div className='showdet'>
                <div className='sticky'></div>
                <div className='sticky2'>
                    {type == 'CONSULTANT' ? <Invpop /> : <></>}
                </div>
            </div>
            {booler ? <Currency symbol={setSymbol} callback={curCall} for='invoices' ad={temp} data={data} setData={setData} /> : <></>}
            <div className='ProjectsTop row'>
                <div className="projleft">Invoices</div>
                <div className="projright row">
                    <button className='' onClick={() => getInvoices()}>refresh</button>&emsp;
                    {type == 'ACCOUNTANT' ? <>
                        {hover ? <><button className='' onClick={() => { setHov(false); changes = [] }}>Cancel</button>&emsp;</> : <></>}
                        {!hover ? <button className='' onClick={() => { setHov(true) }}> Edit </button> : <button className='' onClick={() => { changeInv() }}> Submit </button>}&emsp;
                    </> : <></>}
                    {type == 'CONSULTANT' ? <button onClick={() => document.getElementsByClassName('showdet')[0].classList.add('show_hide')}>Create Invoice</button> : <></>}
                    {/* <div className='column'>
                        <svg width="20" height="6" viewBox="0 0 20 6" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M10 5C14.9706 5 19 4.10457 19 3C19 1.89543 14.9706 1 10 1C5.02944 1 1 1.89543 1 3C1 4.10457 5.02944 5 10 5Z" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                        </svg>
                        <svg width="20" height="19" viewBox="0 0 20 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M1 1C1 3.23 4.871 7.674 6.856 9.805C7.58416 10.5769 7.99291 11.5959 8 12.657V18L12 16V12.657C12 11.596 12.421 10.582 13.144 9.805C15.13 7.674 19 3.231 19 1" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                        </svg>
                    </div> */}
                </div>&emsp;
                <div onClick={() => document.getElementsByClassName('showfil')[0].classList.add('show_hide')} className='column'>
                    <svg width="20" height="6" viewBox="0 0 20 6" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M10 5C14.9706 5 19 4.10457 19 3C19 1.89543 14.9706 1 10 1C5.02944 1 1 1.89543 1 3C1 4.10457 5.02944 5 10 5Z" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                    </svg>
                    <svg width="20" height="19" viewBox="0 0 20 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M1 1C1 3.23 4.871 7.674 6.856 9.805C7.58416 10.5769 7.99291 11.5959 8 12.657V18L12 16V12.657C12 11.596 12.421 10.582 13.144 9.805C15.13 7.674 19 3.231 19 1" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                    </svg>
                </div>
            </div>
            <div className='filterList'>
                {filters.project_name && <Filtertag name={filters.project_name} id='FPname' />}
                {filters.date && <Filtertag name={filters.date} id='FDate' />}
                {filters.due_date && <Filtertag name={filters.due_date} id='FDDate' />}
                {filters.status && <Filtertag name={filters.status} id='FStatus' />}
            </div>
            <Filter get={getInvoices} for='invoice' childFunc={childFunc} data={setData} setFil={setFil} url='account/invoice_filter/' />
            <div className=' top'>
                <table>
                    <tr className='border_bottom'>
                        <th>Project Name</th>
                        {/* <th>Hours</th> */}
                        <th>Rate
                            <span onClick={() => {
                                document.getElementsByClassName('currency')[0].classList.add('show_hide')
                            }
                            } style={{ cursor: 'pointer' }}>
                                <i class="fas fa-ellipsis-v"></i></span>
                        </th><th>Due Date</th><th>Status</th>
                    </tr >
                    {!load ? data.map((inv) => {
                        return <tr onClick={() => {
                            if (!hover) {
                                localStorage.setItem(`invoice-${inv.slug}`, JSON.stringify(inv));
                                navigate(`/invoice/${inv.slug}`)
                            }
                        }} className='border_bottom'>
                            <td>{inv.project_name}</td>
                            {/* <td>{inv.rate}</td> */}
                            <td>{numberWithCommas(inv.Total_rate) + inv.currency}</td>
                            <td>{inv.due_date}</td>
                            {!hover ?
                                <td
                                    style={{
                                        color: inv.status == 'APPROVED' ? '#027C49' : inv.status == 'APPROVED_PAID' ? '#0052B5' :
                                            inv.status.match('REJECTED') ? 'red' : '#DDE113'
                                    }} className='bold'>
                                    {inv.status == 'APPROVED' ? <svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <circle cx="10.5" cy="10.5" r="10.5" fill="#027C49" />
                                        <path d="M8.75502 15.784L4.20502 10.9899C3.93166 10.7019 3.93166 10.2349 4.20502 9.94682L5.19494 8.90377C5.4683 8.61572 5.91154 8.61572 6.1849 8.90377L9.25 12.1333L15.8151 5.21601C16.0885 4.928 16.5317 4.928 16.8051 5.21601L17.795 6.25907C18.0683 6.54709 18.0683 7.01408 17.795 7.30213L9.74498 15.784C9.47159 16.072 9.02838 16.072 8.75502 15.784Z" fill="white" />
                                    </svg> : inv.status == 'APPROVED_PAID' ? <svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <circle cx="10.5" cy="10.5" r="10.5" fill="#0052B5" />
                                        <path d="M8.75502 15.784L4.20502 10.9899C3.93166 10.7019 3.93166 10.2349 4.20502 9.94682L5.19494 8.90377C5.4683 8.61572 5.91154 8.61572 6.1849 8.90377L9.25 12.1333L15.8151 5.21601C16.0885 4.928 16.5317 4.928 16.8051 5.21601L17.795 6.25907C18.0683 6.54709 18.0683 7.01408 17.795 7.30213L9.74498 15.784C9.47159 16.072 9.02838 16.072 8.75502 15.784Z" fill="white" />
                                    </svg> : inv.status.match('REJECTED') ?
                                        <svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <circle cx="10.5" cy="10.5" r="10.5" fill="#FF0000" />
                                            <line x1="5.6247" y1="7.21913" x2="15.6247" y2="15.2191" stroke="white" stroke-width="2" />
                                            <line x1="5.3753" y1="15.2191" x2="15.3753" y2="7.21913" stroke="white" stroke-width="2" />
                                        </svg> : <svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <circle cx="10.5" cy="10.5" r="10.5" fill="#DDE113" />
                                            <path d="M8.75502 15.784L4.20502 10.9899C3.93166 10.7019 3.93166 10.2349 4.20502 9.94682L5.19494 8.90377C5.4683 8.61572 5.91154 8.61572 6.1849 8.90377L9.25 12.1333L15.8151 5.21601C16.0885 4.928 16.5317 4.928 16.8051 5.21601L17.795 6.25907C18.0683 6.54709 18.0683 7.01408 17.795 7.30213L9.74498 15.784C9.47159 16.072 9.02838 16.072 8.75502 15.784Z" fill="white" />
                                        </svg>
                                    }
                                    {inv.status}
                                </td> :
                                <td >
                                    <select onChange={(ed) => { changes.push({ status: ed.target.value, slug: inv.slug }) }}>
                                        <option selected={inv.status == 'NOTUPDATED' ? true : false} value='NOTUPDATED'>NOTUPDATED</option>
                                        <option selected={inv.status == 'REJECTED' ? true : false} value='REJECTED'>REJECTED</option>
                                        <option selected={inv.status == 'APPROVED_PAID' ? true : false} value='APPROVED_PAID'>APPROVED_PAID</option>
                                        <option selected={inv.status == 'APPROVED' ? true : false} value='APPROVED'>APPROVED</option>
                                    </select>
                                </td>}
                        </tr>
                    }):<><TabRen/></>}
                </table>
            </div>
        </div> : <></>
    )
}

